import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Table from 'react-bootstrap/Table';
import Const from '../../../util/Constants';
import MassWhatsAppAPI from '../../../api/MassWhatsAppAPI';
import ApiUiController from '../../../controller/ApiUiController';
import Display from '../../../util/Display';
import withRouter from '../../../util/WithRouter';
import Util from '../../../util/Util';

class MassWhatsAppPreview extends React.Component {

  constructor(props) {
    super(props);
    this.model = reactLocalStorage.getObject(Const.Model).mass_whatsapp;
    this.id = parseInt(props.match.params.id);
    this.data = {};
    this.state = { inApiCall: true };
  }

  componentDidMount() { MassWhatsAppAPI.get(this.id, this.onReceived, this.onFail); }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = res => {
    this.data = res;
    this.setState({ ...this.state, inApiCall: false });
  };

  render() {
    const data = this.data;
    const fields = this.model.fields;
    return (
      <ApiUiController inApiCall={this.state.inApiCall}>
        <section className="pt-4 pb-5">
          <div className="container pt-3">
            <div className="row">
              <div className="col-md-12">
                <Table stripped bordered hover size="md">
                  <thead>
                    <tr>
                      <th>{fields.name.label_name}</th>
                      <th>{fields.template.label_name}</th>
                      <th>{fields.operation_status.label_name}</th>
                      <th>No WhatsApp Sent</th>
                      <th>{fields.created_by.label_name}</th>
                      <th>{fields.created_date.label_name}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{Display.FieldValue(data, 'name', fields)}</td>
                      <td>{Display.FieldValue(data, 'template', fields)}</td>
                      <td>{Display.FieldValue(data, 'operation_status', fields)}</td>
                      <td>{data.report_key ? data.report_key.whatsapp_count : '-'}</td>
                      <td>{Display.FieldValue(data, 'created_by', fields)}</td>
                      <td>{Display.FieldValue(data, 'created_date', fields)}</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </section>
      </ApiUiController>
    );
  }
}
export default withRouter(MassWhatsAppPreview);